import { useEffect } from 'react';
import { Text, View } from 'react-native';
import { Platform } from 'utils/platform';

import { FONT_SIZES, SUBTITLE_COLORS, useSubtitlesSettings } from './hooks/SubtitlesContext';

import { usePlayer } from 'components/Player/context';

interface SubtitlesProps {
  currentTime: number;
}

export function Subtitles({ currentTime }: SubtitlesProps) {
  const { isLive } = usePlayer();
  const { enabled, fontSize, color, text, onProgress } = useSubtitlesSettings();

  useEffect(() => {
    if (enabled) {
      onProgress(currentTime);
    }
  }, [currentTime, onProgress, enabled]);

  if (!enabled || !text || isLive) {
    return null;
  }

  return (
    <View
      style={{
        position: 'absolute',
        left: 16,
        right: 16,
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        bottom: Platform.isTV ? 50 : 25,
        borderRadius: 8,
        paddingHorizontal: 12,
        paddingVertical: 6,
      }}>
      <Text
        style={{
          color: SUBTITLE_COLORS[color],
          fontSize: FONT_SIZES[fontSize],
          textAlign: 'center',
        }}>
        {text}
      </Text>
    </View>
  );
}
